import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconMathEquals: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-outlined-radius-0-stroke-1-IconMathEquals"><Path d="M4.5 9.5H19.5" stroke="currentColor" strokeLinecap="square"/><Path d="M4.5 14.5H19.5" stroke="currentColor" strokeLinecap="square"/></CentralIconBase>;
});

export default IconMathEquals;
